/* eslint-disable react/prop-types */
import React from 'react';
import { jsPDF } from 'jspdf';

export const GeneratePDF = ({ data }): React.ReactElement => {
    const generate = (): void => {
        const doc = new jsPDF('l', 'pt', 'a1') as any;
        const header = Object.keys(data[0]).map(i => {
            return {
                header: i,
                dataKey: i,
            };
        });

        doc.autoTable({
            body: data,
            columns: header,
            tableWidth: 2000,
            cellWidth: 50,
            styles: {
                overflow: 'linebreak',
                overflowColumns: 'linebreak',
                fontSize: 14,
            },
        });
        doc.save('loaddata.pdf');
    };

    return (
        <div>
            <button onClick={generate} className={`CustomButton-Default ${'CustomButton-Plain'} `}>
                PDF
            </button>
        </div>
    );
};

export default GeneratePDF;
